import { ROUTE_NAME } from '@constants';

const community = {
  path: '/community',
  redirect: '/community/news',
  meta: {
    // isDesktop: true,
    breadcrumb: true,
    breadcrumbName: '정보마당',
    navMenu: true,
    description: '송추컨트리클럽의 소식을 안내해 드립니다.',
  },
  children: [
    {
      name: ROUTE_NAME.News,
      path: 'news',
      component: () => import('@views/community/News.vue'),
      meta: {
        breadcrumb: true,
        breadcrumbName: '송추소식',
        mobileVisible: true,
      },
    },
    {
      name: ROUTE_NAME.NewsView,
      path: 'news/:postId',
      component: () => import('@views/community/NewsView.vue'),
      meta: {
        breadcrumb: false,
        subName: 'News',
      },
    },
    {
      name: ROUTE_NAME.NewsWrite,
      path: 'news/write',
      component: () => import('@views/community/NewsWrite.vue'),
      meta: {
        breadcrumb: false,
        subName: 'News',
      },
    },
    {
      name: ROUTE_NAME.NewsModify,
      path: 'news/modify/:postId',
      component: () => import('@views/community/NewsModify.vue'),
      meta: {
        breadcrumb: false,
        subName: 'News',
      },
    },
    {
      name: ROUTE_NAME.RelatedSites,
      path: 'related-sites',
      component: () => import('@views/community/RelatedSites.vue'),
      meta: {
        breadcrumb: true,
        breadcrumbName: '관련사이트',
      },
    },
  ],
};
export default community;
